export const splitOverrides = process.env.REACT_APP_SPLIT_OVERRIDES;
